/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Thu Nov 23 2023 15:31:38
 */

// @flow
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Modal, Icon } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import WelcomeImage from 'src/assets/images/standard-search/welcome.png';
import Emitter, { EVENT_KEY } from 'src/libs/eventEmitter';
import { connect } from 'react-redux';
import * as dashboardV3Actions from 'actions/dashboard-v3-actions';

const WelcomePopup = props => {
  const { i18n, showSearchOnboarding = false, disableSearchOnboarding } = props;
  const [popupOpened, setPopupOpened] = useState(showSearchOnboarding);

  const turnOff = useCallback(() => {
    setPopupOpened(false);
    disableSearchOnboarding(i18n);
  }, [disableSearchOnboarding, i18n]);

  const getStarted = useCallback(() => {
    turnOff();
    Emitter.emit(EVENT_KEY.START_STANDARD_SEARCH_GUIDE_TOUR);
  }, [turnOff]);

  return (
    <Modal
      noScroll
      open={popupOpened}
      primaryAction={{
        content: i18n.translate('AdminHTML.StandardSearch.Actions.getStarted'),
        onAction: getStarted
      }}>
      <Modal.Section flush>
        <div className="BC-Component__SearchWelcomePopup">
          <div className="SearchWelcomePopup__Close" onClick={turnOff}>
            <Icon source={MobileCancelMajor} color="subdued" />
          </div>
          <div className="SearchWelcomePopup__Banner">
            <img src={WelcomeImage} alt="Search onboarding banner" />
          </div>
          <div className="SearchWelcomePopup__Content">
            <div className="title">
              {i18n.translate('AdminHTML.StandardSearch.WelcomeBlock.title')}
            </div>
            <div className="description">
              {i18n.translate('AdminHTML.StandardSearch.WelcomeBlock.content')}
            </div>
          </div>
        </div>
      </Modal.Section>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => ({
  disableSearchOnboarding: i18n => dispatch(dashboardV3Actions.disableSearchOnboarding(i18n))
});

const mapStateToProps = state => {
  const { oauth = {} } = state;

  const onboardingV3 = _.get(oauth, 'tenantApp.settings.onboardingV3', {});
  const onboardingEnabled = onboardingV3?.status === 'active' && !!onboardingV3?.settings?.enable;
  const showSearchOnboarding =
    onboardingEnabled && !!onboardingV3?.settings?.showStandardSearchOnboarding;

  return { showSearchOnboarding };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(WelcomePopup));
